export default __webpack_public_path__ + "static/blob4-5ad89a7be2ab731df2a44ccecf1696fb.svg";